export default __webpack_public_path__ + "static/figure-pear-20260722-6f954763255948fe3cb69c676cde32c9.jpg";